import React from "react";

// Material-UI Core
import {makeStyles} from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Divider from '@material-ui/core/Divider'

// Custom Style
import dividerTextStyle from "../../styles/jss/components/divider/dividerTextStyle"


const useStyles = makeStyles(theme => dividerTextStyle(theme))

const DividerText = ({ children, textAlign, ...props }) => {
	const classes = useStyles()


	return (
		<Grid container alignItems="center" spacing={3} {...props}>
			<Grid item xs={textAlign === 'left' ? 2 : true}>
				<Divider />
			</Grid>

			<Grid item className={classes.title}>
				{children}
			</Grid>
			
			<Grid item xs={textAlign === 'right' ? 2 : true}>
				<Divider />
			</Grid>
		</Grid>

	)


}


export default DividerText